import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import placeholderUserImage from './user.svg?url';
import { Image } from './style';

function ProfilePicture({
  alt,
  className,
  size = 'medium', // default value directly in parameter
  src,
  setDeleteButtonState
}) {
  const handleLoadError = useCallback(event => {
    if (event.target.src !== placeholderUserImage) {
      event.target.src = placeholderUserImage;
      if (typeof setDeleteButtonState === 'function') {
        setDeleteButtonState(false);
      }
    }
  }, [setDeleteButtonState]);

  useEffect(() => {
    if (src && typeof setDeleteButtonState === 'function') {
      setDeleteButtonState(true);
    }
  }, [src, setDeleteButtonState]);

  return (
    <Image
      alt={alt}
      className={className}
      size={size}
      src={src || placeholderUserImage}
      onError={handleLoadError}
    />
  );
}

ProfilePicture.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string,
  src: PropTypes.string,
  setDeleteButtonState: PropTypes.func
};

export default ProfilePicture;
